import {
  Box,
  Card,
  ContentBlock,
  Heading,
  Link,
  Stack,
  Strong,
  Text,
} from 'braid-design-system';
import React from 'react';

const Confirmation = () => (
  <Box background="brandAccent" paddingTop="xxlarge" paddingBottom="large">
    <ContentBlock>
      <Stack space="xlarge">
        <Heading align="center" weight="weak" level="1">
          Thanks, we&apos;ll be in touch shortly
        </Heading>
        <Card rounded>
          <Box padding="large">
            <Stack space="large">
              <Text>
                Thanks for your expression of interest in Boosted Ads for your
                business listing.
              </Text>
              <Text>
                A member of our team will be in touch shortly to provide you
                with further information and next steps.
              </Text>
              <Stack space="small">
                <Text>
                  In the meantime, you can find more information here:{' '}
                </Text>
                <Text>
                  <Strong>
                    <Link href="https://www.seekbusiness.com.au/private-seller-info">
                      https://www.seekbusiness.com.au/private-seller-info
                    </Link>
                  </Strong>
                </Text>
              </Stack>
              <Text>Thanks and speak soon,</Text>
              <Text>
                <Strong>The SEEK Business team</Strong>
              </Text>
            </Stack>
          </Box>
        </Card>
      </Stack>
    </ContentBlock>
  </Box>
);

export default Confirmation;
